import React from 'react';
import { FeatureFlagsContext } from 'providers/FeatureFlagsProvider';

export default function useFeatureFlags() {
  return React.useContext(FeatureFlagsContext);
}
